import React from "react";

const DupontRadio = ({
  text,
  value,
  checked,
  name,
  fontsize,
  isRequired,
  disabled,
}) => {
  return (
    <label className={`radiocontainer descriptionText ${fontsize}`}>
      {text}{" "}
      {isRequired && (
        <span style={{ color: "red", marginLeft: "-2px" }}>*</span>
      )}
      <input
        className="radioLabel"
        type="radio"
        value={value}
        defaultChecked={checked}
        name={name}
        checked={checked}
        disabled={disabled}
      />
      <span className="radioButton"> </span>
    </label>
  );
};
export default DupontRadio;
